'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _chatrenderer = require('./chatrenderer');

var _chatrenderer2 = _interopRequireDefault(_chatrenderer);

require('../css/custom.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatBox = function (_Component) {
    _inherits(ChatBox, _Component);

    function ChatBox() {
        _classCallCheck(this, ChatBox);

        return _possibleConstructorReturn(this, (ChatBox.__proto__ || Object.getPrototypeOf(ChatBox)).apply(this, arguments));
    }

    _createClass(ChatBox, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_chatrenderer2.default, this.props)
            );
        }
    }]);

    return ChatBox;
}(_react.Component);

ChatBox.propTypes = {
    initialMesage: _propTypes2.default.string,
    chatteeName: _propTypes2.default.string,
    chatteeId: _propTypes2.default.number,
    meetingTitle: _propTypes2.default.string,
    isLoading: _propTypes2.default.bool,
    position: _propTypes2.default.string,
    height: _propTypes2.default.string,
    skinName: _propTypes2.default.string,
    messages: _propTypes2.default.array,
    participants: _propTypes2.default.array,
    user_type: _propTypes2.default.string
};

ChatBox.defaultProps = {
    initialMesage: "",
    chatteeName: 'Guest',
    chatteeId: -1,
    meetingTitle: 'This meeting is about?',
    isLoading: true,
    position: 'bottom-right',
    height: '350px',
    skinName: 'red',
    messages: [],
    participants: [],
    user_type: 'client'
};

exports.default = ChatBox;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatbox.js